module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/team/jim-lampros-1e225b9015aadcade33813bcc77cb256.jpg";